var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{style:(_vm.height ? 'height:' + _vm.height : '')},[_c('vuescroll',{attrs:{"ops":_vm.ops}},[_vm._t("scrollableContent")],2)],1),_vm._t("nonScrollableFooter")],2)}
var staticRenderFns = []

export { render, staticRenderFns }